// --- Custom Countdown Timer Script (Resets at Midnight Local Time) ---
function initializeCountdownTimer() {
    const countdownElement = document.getElementById('custom-product-timer');

    if (!countdownElement) return; // Stop if the element isn't on the page

    const interval = setInterval(function() {
        const now = new Date();
        
        // 1. SET TARGET TO MIDNIGHT TONIGHT (23:59:59)
        const targetTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();
        
        let distance = targetTime - now.getTime();

        // If for some reason it's past midnight (distance < 0), reset for tomorrow night
        if (distance < 0) {
             const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 23, 59, 59);
             distance = tomorrow.getTime() - now.getTime();
        }

        // TIME CALCULATIONS
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // FORMATTING (Add leading zero if less than 10)
        const formatTime = (time) => String(time).padStart(2, '0');

        // OUTPUT TO HTML
        // Note: We use your existing class 'timer-display'
        countdownElement.querySelector('.timer-display').innerHTML = 
            formatTime(hours) + " : " + formatTime(minutes) + " : " + formatTime(seconds);

    }, 1000);
}

// Run the function when the page loads
window.addEventListener('DOMContentLoaded', initializeCountdownTimer);